import { html } from '../utils/security.js';
import { createAppFactorySession } from '../api.js';

export const renderAppFactoryNewView = async (container) => {
  container.innerHTML = html`
    <div class="container">
      <div class="page-header">
        <h1>Neue App Factory Session</h1>
        <p class="muted">Starte ein strukturiertes Kundengespräch mit Leitfaden</p>
      </div>

      <form id="new-session-form" class="form-container">
        <div class="form-group">
          <label for="guideline-select">Leitfaden auswählen</label>
          <select id="guideline-select" required>
            <option value="default-v1">Standard App Development Guideline (v1.0)</option>
          </select>
          <p class="muted small">Der Leitfaden bestimmt, welche Fragen im Gespräch beantwortet werden müssen.</p>
        </div>

        <div class="form-group">
          <label for="customer-id">Kunden-ID (optional)</label>
          <input type="text" id="customer-id" placeholder="z.B. CUST-12345" />
        </div>

        <div class="form-group">
          <label for="project-id">Projekt-ID (optional)</label>
          <input type="text" id="project-id" placeholder="z.B. PROJ-67890" />
        </div>

        <div class="form-actions">
          <button type="button" id="cancel-btn" class="ghost-button">Abbrechen</button>
          <button type="submit" class="primary-button">Session erstellen</button>
        </div>
      </form>
    </div>
  `;

  const form = document.getElementById('new-session-form');
  const cancelBtn = document.getElementById('cancel-btn');

  form.addEventListener('submit', async (e) => {
    e.preventDefault();

    const guidelineId = document.getElementById('guideline-select').value;
    const customerId = document.getElementById('customer-id').value.trim() || undefined;
    const projectId = document.getElementById('project-id').value.trim() || undefined;

    const submitBtn = form.querySelector('button[type="submit"]');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Erstelle Session...';

    try {
      const response = await createAppFactorySession({
        guidelineId,
        customerId,
        projectId,
      });

      const sessionId = response?.sessionId;
      if (!sessionId) {
        throw new Error('No session ID returned');
      }

      // Redirect to session view
      window.location.hash = `#/app-factory/session/${sessionId}`;
    } catch (error) {
      console.error('Failed to create session:', error);
      alert(`Fehler beim Erstellen der Session: ${error.message}`);
      submitBtn.disabled = false;
      submitBtn.textContent = 'Session erstellen';
    }
  });

  cancelBtn.addEventListener('click', () => {
    window.location.hash = '#/app-factory';
  });
};
